import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("선물하기")
const _hoisted_3 = {
  id: "content",
  class: "content con_product_detail"
}
const _hoisted_4 = {
  key: 0,
  class: "product_detail_wrap"
}
const _hoisted_5 = { class: "product_notice_area" }
const _hoisted_6 = { class: "product_notice_bx" }
const _hoisted_7 = {
  class: "dimmed",
  style: {"display":"block"}
}
const _hoisted_8 = /*#__PURE__*/_createTextVNode("비회원 주문")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_header_component = _resolveComponent("header-component")
  const _component_product_info_component = _resolveComponent("product-info-component")
  const _component_product_detail_image_component = _resolveComponent("product-detail-image-component")
  const _component_product_usage_component = _resolveComponent("product-usage-component")
  const _component_product_notice_component = _resolveComponent("product-notice-component")
  const _component_order_button_component = _resolveComponent("order-button-component")
  const _component_top_button_component = _resolveComponent("top-button-component")
  const _component_authentication_prompt_component = _resolveComponent("authentication-prompt-component")
  const _component_cellphone_authentication_component = _resolveComponent("cellphone-authentication-component")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", {
      id: "wrap",
      class: ["wrap", {app_view: _ctx.isApp}]
    }, [
      _createVNode("div", _hoisted_1, [
        _createVNode(_component_header_component, null, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        })
      ]),
      _createVNode("div", _hoisted_3, [
        (_ctx.loadingCompleted)
          ? (_openBlock(), _createBlock("div", _hoisted_4, [
              _createVNode(_component_product_info_component),
              _createVNode(_component_product_detail_image_component),
              _createVNode("div", _hoisted_5, [
                _createVNode("div", _hoisted_6, [
                  _createVNode(_component_product_usage_component, { product: _ctx.product }, null, 8, ["product"])
                ]),
                _createVNode(_component_product_notice_component)
              ]),
              _createVNode(_component_order_button_component, { onOpenAuthenticationPromptPopup: _ctx.openAuthenticationPromptPopup }, null, 8, ["onOpenAuthenticationPromptPopup"])
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_top_button_component)
      ])
    ], 2),
    _withDirectives(_createVNode("div", _hoisted_7, null, 512), [
      [_vShow, _ctx.showDimmed]
    ]),
    _withDirectives(_createVNode(_component_authentication_prompt_component, {
      onOpenLoginPopup: _ctx.openLoginPopup,
      onOpenCellphoneAuthenticationPopup: _ctx.openCellphoneAuthenticationPopup,
      onCloseAuthenticationPromptPopup: _ctx.closeAuthenticationPromptPopup
    }, {
      text: _withCtx(() => [
        _hoisted_8
      ]),
      _: 1
    }, 8, ["onOpenLoginPopup", "onOpenCellphoneAuthenticationPopup", "onCloseAuthenticationPromptPopup"]), [
      [_vShow, _ctx.showLoginPopup]
    ]),
    _withDirectives(_createVNode(_component_cellphone_authentication_component, { onCloseCellphoneAuthenticationPopup: _ctx.closeCellphoneAuthenticationPopup }, null, 8, ["onCloseCellphoneAuthenticationPopup"]), [
      [_vShow, _ctx.showCertificationPopup]
    ])
  ], 64))
}